export const CUSTOM_DOCUMENTATION_REQUIRED_RESPONSES = {
  EMPTY: {
    status: "ok",
    payload: {
      created_at: "2022-03-02T10:15:23+00:00",
      updated_at: "2022-03-02T10:15:23+00:00",
      id: "36cf8983-355d-4e46-9470-ef094d365868",
      required_files: [
        {
          id: "9d4cf4b2-f312-4b33-9f7d-9cfd20d6b6b0",
          description: "Una de tus \u00faltimas 3 n\u00f3minas",
          name: "payroll",
          status: "pending",
          uploaded_files: [],
          annotation: null,
        },
      ],
      are_documents_confirmed: false,
      are_required_files_uploaded: false,
      loan_id: "f4fc4ee2-c127-4a8f-ae2e-d65fbefd00e8",
      borrower_id: "08156338-cce3-4493-921a-d4ee815b4e20",
    },
    identifier:
      "urn:nemuru:financial:documentationRequired:36cf8983-355d-4e46-9470-ef094d365868",
  },
  COMPLETED: {
    status: "ok",
    payload: {
      created_at: "2022-03-14T14:27:23+00:00",
      updated_at: "2022-03-14T14:31:29+00:00",
      id: "97df6b80-a258-447a-b734-9ab2d3b8a72f",
      required_files: [
        {
          id: "08114af0-fc5e-4e36-b9cc-9bf66b08a129",
          description: "Anverso del documento de identidad v\u00e1lido",
          name: "document_id_front",
          status: "uploaded",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [
            {
              name: "document_id_front.jpg",
              path: "loans/f2075bd1-48c4-4dd9-b780-095606c8e9f3/borrowers/9b6ed9f2-15f1-4edf-8d79-399647cf4ba6/document_id_front/document_id_front.jpg",
              mime_type: "image/jpeg",
            },
          ],
        },
        {
          id: "2137073e-0362-4ae6-995b-5acc2691d8a5",
          description: "V\u00eddeo extra\u00eddo durante el proceso de KYC",
          name: "kyc_video",
          status: "uploaded",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [
            {
              name: "kyc_video.mp4",
              path: "loans/f2075bd1-48c4-4dd9-b780-095606c8e9f3/borrowers/9b6ed9f2-15f1-4edf-8d79-399647cf4ba6/kyc_video/kyc_video.mp4",
              mime_type: "video/mp4",
            },
          ],
        },
        {
          id: "59113bdb-80ba-490a-b3a8-54bc855098d0",
          description: "Reverso del documento de identidad v\u00e1lido",
          name: "document_id_back",
          status: "uploaded",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [
            {
              name: "document_id_back.jpg",
              path: "loans/f2075bd1-48c4-4dd9-b780-095606c8e9f3/borrowers/9b6ed9f2-15f1-4edf-8d79-399647cf4ba6/document_id_back/document_id_back.jpg",
              mime_type: "image/jpeg",
            },
          ],
        },
        {
          id: "5b20c3b5-68ac-48a9-b289-1e28af392961",
          description:
            "Certificado de titularidad bancaria, recibo o screenshot banca online (debe reflejarse siempre IBAN, nombre y DNI del titular)",
          name: "bank_account_ownership_documentation",
          status: "uploaded",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [
            {
              name: "EUREES22-182121.pdf",
              path: "loans/f2075bd1-48c4-4dd9-b780-095606c8e9f3/borrowers/9b6ed9f2-15f1-4edf-8d79-399647cf4ba6/bank_account_ownership_documentation/EUREES22-182121.pdf",
              mime_type: "application/pdf",
            },
          ],
        },
        {
          id: "8c465392-fd03-4945-8331-3b395e911588",
          description:
            "Documento generado mediante el proceso de KYC comparando las im\u00e1genes faciales del documento y del videostream",
          name: "biometrics_document",
          status: "uploaded",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [
            {
              name: "biometrics_document.pdf",
              path: "loans/f2075bd1-48c4-4dd9-b780-095606c8e9f3/borrowers/9b6ed9f2-15f1-4edf-8d79-399647cf4ba6/biometrics_document/biometrics_document.pdf",
              mime_type: "application/pdf",
            },
          ],
        },
        {
          id: "9d4cf4b2-f312-4b33-9f7d-9cfd20d6b6b0",
          description: "Una de tus \u00faltimas 3 n\u00f3minas",
          name: "payroll",
          status: "uploaded",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [
            {
              name: "EUREES22-182122.pdf",
              path: "loans/f2075bd1-48c4-4dd9-b780-095606c8e9f3/borrowers/9b6ed9f2-15f1-4edf-8d79-399647cf4ba6/payroll/EUREES22-182122.pdf",
              mime_type: "application/pdf",
            },
          ],
        },
      ],
      are_documents_confirmed: true,
      are_required_files_uploaded: true,
      loan_id: "f2075bd1-48c4-4dd9-b780-095606c8e9f3",
      borrower_id: "9b6ed9f2-15f1-4edf-8d79-399647cf4ba6",
    },
    identifier:
      "urn:nemuru:financial:documentationRequired:97df6b80-a258-447a-b734-9ab2d3b8a72f",
  },
  UNCOMPLETED: {
    status: "ok",
    payload: {
      created_at: "2022-03-14T14:27:23+00:00",
      updated_at: "2022-03-14T14:31:29+00:00",
      id: "97df6b80-a258-447a-b734-9ab2d3b8a72f",
      required_files: [
        {
          id: "08114af0-fc5e-4e36-b9cc-9bf66b08a129",
          description: "Anverso del documento de identidad v\u00e1lido",
          name: "document_id_front",
          status: "uploaded",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [
            {
              name: "document_id_front.jpg",
              path: "loans/f2075bd1-48c4-4dd9-b780-095606c8e9f3/borrowers/9b6ed9f2-15f1-4edf-8d79-399647cf4ba6/document_id_front/document_id_front.jpg",
              mime_type: "image/jpeg",
            },
          ],
        },
        {
          id: "2137073e-0362-4ae6-995b-5acc2691d8a5",
          description: "V\u00eddeo extra\u00eddo durante el proceso de KYC",
          name: "kyc_video",
          status: "uploaded",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [
            {
              name: "kyc_video.mp4",
              path: "loans/f2075bd1-48c4-4dd9-b780-095606c8e9f3/borrowers/9b6ed9f2-15f1-4edf-8d79-399647cf4ba6/kyc_video/kyc_video.mp4",
              mime_type: "video/mp4",
            },
          ],
        },
        {
          id: "59113bdb-80ba-490a-b3a8-54bc855098d0",
          description: "Reverso del documento de identidad v\u00e1lido",
          name: "document_id_back",
          status: "uploaded",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [
            {
              name: "document_id_back.jpg",
              path: "loans/f2075bd1-48c4-4dd9-b780-095606c8e9f3/borrowers/9b6ed9f2-15f1-4edf-8d79-399647cf4ba6/document_id_back/document_id_back.jpg",
              mime_type: "image/jpeg",
            },
          ],
        },
        {
          id: "5b20c3b5-68ac-48a9-b289-1e28af392961",
          description:
            "Certificado de titularidad bancaria, recibo o screenshot banca online (debe reflejarse siempre IBAN, nombre y DNI del titular)",
          name: "bank_account_ownership_documentation",
          status: "uploaded",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [
            {
              name: "EUREES22-182121.pdf",
              path: "loans/f2075bd1-48c4-4dd9-b780-095606c8e9f3/borrowers/9b6ed9f2-15f1-4edf-8d79-399647cf4ba6/bank_account_ownership_documentation/EUREES22-182121.pdf",
              mime_type: "application/pdf",
            },
          ],
        },
        {
          id: "8c465392-fd03-4945-8331-3b395e911588",
          description:
            "Documento generado mediante el proceso de KYC comparando las im\u00e1genes faciales del documento y del videostream",
          name: "biometrics_document",
          status: "uploaded",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [
            {
              name: "biometrics_document.pdf",
              path: "loans/f2075bd1-48c4-4dd9-b780-095606c8e9f3/borrowers/9b6ed9f2-15f1-4edf-8d79-399647cf4ba6/biometrics_document/biometrics_document.pdf",
              mime_type: "application/pdf",
            },
          ],
        },
        {
          id: "9d4cf4b2-f312-4b33-9f7d-9cfd20d6b6b0",
          description: "Una de tus \u00faltimas 3 n\u00f3minas",
          name: "payroll",
          status: "pending",
          is_sent: false,
          sent_date: null,
          annotation: null,
          uploaded_files: [],
        },
      ],
      are_documents_confirmed: true,
      are_required_files_uploaded: true,
      loan_id: "f2075bd1-48c4-4dd9-b780-095606c8e9f3",
      borrower_id: "9b6ed9f2-15f1-4edf-8d79-399647cf4ba6",
    },
    identifier:
      "urn:nemuru:financial:documentationRequired:97df6b80-a258-447a-b734-9ab2d3b8a72f",
  },
};

export const CUSTOM_DECLARED_INCOME = {
  status: "ok",
  payload: {
    created_at: "2022-03-04T12:11:49+00:00",
    updated_at: "2022-03-04T12:11:49+00:00",
    id: "43f24288-7ea4-4284-8fa6-a453ccd96cad",
    type: "declared_income",
    valid: true,
    net_income: {
      annual_net_income: { currency: "EUR", amount: 15000.0 },
      monthly_net_income: { currency: "EUR", amount: 1000.0 },
      net_income_type: "salary",
    },
    documentation_file_type: null,
  },
  identifier: "urn:nemuru:risk:income:43f24288-7ea4-4284-8fa6-a453ccd96cad",
};

export const CUSTOM_STRUCTURE = {
  status: "ok",
  payload: {
    created_at: "2020-06-11T15:30:26+00:00",
    updated_at: "2020-06-11T15:30:48+00:00",
    merchant: {
      id: "6fef65a6-1e5f-11e9-ab34-d662bd873d88",
      business_name: "Pinturas Manolo",
      segment: "gold",
      category: "home_improvement",
      channels: [
        {
          id: "7e2a959a-3ba4-4fb3-b531-c1291b068eef",
          description: "Tienda fisica",
          type: "store",
          agents: [
            {
              id: "23f4dd4f-79aa-4ed2-ad7d-5c657eb4c7f7",
              name: "store001",
              allowed_asset_types: [
                "auto",
                "home_improvement",
                "travel",
                "health",
              ],
            },
            {
              id: "23f4dd4f-79aa-4ed2-ad7d-5c657eb4c7f8",
              name: "Manuel Pinturo",
              allowed_asset_types: [
                "education",
                "home_improvement",
                "travel",
                "health",
              ],
            },
          ],
        },
      ],
    },
  },
};

export const CUSTOM_GET_SIGNATURE_URL_BY_LOAN_ID = {
  status: "ok",
  identifier: "urn:nemuru:financial:loan_application:xxx",
  payload: {
    created_at: "2020-06-11T15:30:26+00:00",
    updated_at: "2020-06-11T15:30:48+00:00",
    id: "6fef65a6-1e5f-11e9-ab34-d662bd873d88",
    integration_type: "embedded_saml",
    saml: "XXXXXX",
    url: "https://www.demo.logalty.es:443/lgt/lgtfrontend/login/samlLogin",
    url_line: null,
    url_privacy_policy: null,
  },
};

export const CUSTOM_LOAN_BEFORE_AGENT_SEQUENCE = {
  status: "ok",
  payload: {
    created_at: "2022-04-28T10:34:25+00:00",
    updated_at: "2022-04-28T10:34:38+00:00",
    id: "17fa8e1d-b26b-4d52-96a8-c769989149b1",
    status: "status_initial",
    loan_conditions: {
      currency: "EUR",
      due_date: 1,
      program: { name: "zero_program", merchant_discount_percentage: 0.07 },
      product: "consumer_loan",
      annual_interest: 0.0,
      principal: { currency: "EUR", amount: 8555.0 },
      loan_calculator: {
        currency: "EUR",
        setup_fee: {
          type: "type_upfront",
          fee_amount: { currency: "EUR", amount: 0.0 },
        },
        insurance: { value: "no", is_insurance_financed: false },
        grace_period: 0.0,
        term: {
          period: 24.0,
          type: "type_period",
          interval: "P1M",
          number_of_payments: 24,
        },
        tae: 0.0,
        annual_interest: 0.0,
        total_interest_paid: { currency: "EUR", amount: 0.0 },
        total_amount_paid: { currency: "EUR", amount: 8555.0 },
        user_defined_quota: { currency: "EUR", amount: 356.46 },
      },
    },
    borrower_id: "7bf76a76-6c6b-4dcb-b225-e39e59ab10e4",
    onboarding_details: [
      {
        id: "c6e8ee27-0eda-43a6-8449-a2ffa3aec486",
        type: "borrower",
        fulfilled_by: "borrower_pos",
        role: "borrower",
        invitation: {
          email: "javier.hernandez@nemuru.com",
          full_name: { first_name: "Joan", last_name: "D'ou" },
          phone_number: "+34676632358",
          expires_on: "2022-05-28T00:00:00+00:00",
          relation: null,
          document_number: "46720427k",
        },
        user_details: null,
        borrower_bank_reader_id: null,
        origination_risk_values_id: null,
        declared_income_id: null,
      },
    ],
    borrower_cash_in_cash_out_method_id: null,
    merchant_cash_in_cash_out_method_id: null,
    merchant_id: "0b0a371c-e993-43d5-8f55-8551ca61daa9",
    agent_id: "6332297f-5cb2-4622-bf12-a4a21e2cf114",
    merchant_category: "home_staging",
    asset_reference: [
      { id: "014fd487-1bc7-43f1-9089-d9bb71e2fd96", type: "other" },
    ],
    asset_details: {
      total_budget: { currency: "EUR", amount: 8555.0 },
      job_description: "producto",
      require_address: false,
    },
    loan_asset: {
      max_initial_asset_step: 0.5,
      loan_asset_steps: [],
      total_pending_loan_asset_steps_amount: {
        amount: 8555.0,
        currency: "EUR",
      },
    },
    lender_risk_values_id: null,
    loan_application_ids: null,
    loan_application_selected: null,
    borrower_cash_in_cash_out_method_account_number: null,
    choose_loan_application_first_call: null,
    loan_approval_status: null,
    desist_reason: null,
  },
  identifier: "urn:nemuru:financial:loan:17fa8e1d-b26b-4d52-96a8-c769989149b1",
};

export const CUSTOM_GET_AGENT = {
  status: "ok",
  payload: {
    created_at: "2021-02-18T09:38:09+00:00",
    updated_at: "2021-03-17T12:11:13+00:00",
    id: "3796e028-5bd7-4cb8-8e53-469099fb8aed",
    allowed_asset_types: ["home_improvement"],
    name: "Ventas Web",
    username: "claudia.manchon+webikea@nemuru.com",
    is_blocked: false,
    pricing_ids: [
      "ee865fa5-7aa5-4b01-b2cc-cf856d1912be",
      "815b287c-c8f6-462b-ae58-3c2fb8df9c02",
      "2ab207dc-76b2-4ddc-b2bb-7458ee7b7110",
      "cd361e58-b873-40ee-aa55-a683cd17c37a",
      "43a4e301-186e-458d-b5ce-dffa387ac662",
      "4f443b1f-1d8f-4050-9eef-81ad8b9a5276",
      "5ed3da10-f1b4-4759-b774-0f018925c9f8",
      "da249f22-8f63-4c25-ad36-9d7388c6bfed",
      "ac955374-1d48-435c-981c-a313cad9c5e3",
      "2df8cd4f-554e-48aa-8214-58cc2f084949",
    ],
    range_period_min: 4.0,
    range_period_max: 12.0,
    range_principal_min: 500.0,
    range_principal_max: 10000.0,
    allowed_products: ["consumer_loan"],
    communications_are_allowed: false,
    quota_selection_by_borrower_is_allowed: false,
    are_certifications_enabled: true,
    is_bank_reader_enabled: true,
    max_bank_reader_attempts: 4,
    is_documentation_required_management_enabled: true,
    is_status_analysing_enabled: true,
    custom_theme: "caixabank",
    custom_registry: "default",
    custom_language: "english",
  },
  identifier: "urn:nemuru:financial:agent:3796e028-5bd7-4cb8-8e53-469099fb8aed",
};

export const CUSTOM_CAIXABANK_KYC = {
  status: "ok",
  payload: {
    created_at: "2021-02-18T09:38:09+00:00",
    updated_at: "2021-03-17T12:11:13+00:00",
    id: "3796e028-5bd7-4cb8-8e53-469099fb8aed",
    allowed_asset_types: ["home_improvement"],
    name: "Ventas Web",
    username: "claudia.manchon+webikea@nemuru.com",
    is_blocked: false,
    pricing_ids: [
      "ee865fa5-7aa5-4b01-b2cc-cf856d1912be",
      "815b287c-c8f6-462b-ae58-3c2fb8df9c02",
      "2ab207dc-76b2-4ddc-b2bb-7458ee7b7110",
      "cd361e58-b873-40ee-aa55-a683cd17c37a",
      "43a4e301-186e-458d-b5ce-dffa387ac662",
      "4f443b1f-1d8f-4050-9eef-81ad8b9a5276",
      "5ed3da10-f1b4-4759-b774-0f018925c9f8",
      "da249f22-8f63-4c25-ad36-9d7388c6bfed",
      "ac955374-1d48-435c-981c-a313cad9c5e3",
      "2df8cd4f-554e-48aa-8214-58cc2f084949",
    ],
    range_period_min: 4.0,
    range_period_max: 12.0,
    range_principal_min: 500.0,
    range_principal_max: 10000.0,
    allowed_products: ["consumer_loan"],
    communications_are_allowed: false,
    quota_selection_by_borrower_is_allowed: false,
    are_certifications_enabled: true,
    is_bank_reader_enabled: true,
    max_bank_reader_attempts: 4,
    is_documentation_required_management_enabled: true,
    is_status_analysing_enabled: true,
    custom_theme: "caixabank",
    custom_registry: "default",
    custom_language: "english",
  },
  identifier: "urn:nemuru:financial:agent:3796e028-5bd7-4cb8-8e53-469099fb8aed",
};
